import { render } from "./enrolments-review-section.vue?vue&type=template&id=288109e8&ts=true"
import script from "./enrolments-review-section.ts?vue&type=script&lang=ts&external"
export * from "./enrolments-review-section.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__